<template>
  <footer class="footer">
    <div class="container-fluid">
  
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
